// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.backgroundremover=NEXT_PUBLIC_RPC_BACKGROUNDREMOVER_URL,service.creativefabrica.vectorizer=NEXT_PUBLIC_RPC_VECTORIZER_URL,service.creativefabrica.social=NEXT_PUBLIC_RPC_SOCIAL_URL,service.creativefabrica.uploads=NEXT_PUBLIC_RPC_UPLOADS_URL,service.creativefabrica.studio=NEXT_PUBLIC_RPC_STUDIO_URL,service.creativefabrica.content=NEXT_PUBLIC_RPC_CONTENT_URL,service.creativefabrica.studiofeed=NEXT_PUBLIC_RPC_STUDIOFEED_URL,service.creativefabrica.studiomediamatrix=NEXT_PUBLIC_RPC_STUDIOMEDIAMATRIX_URL,service.creativefabrica.preset=NEXT_PUBLIC_RPC_PRESET_URL,service.creativefabrica.flow=NEXT_PUBLIC_RPC_FLOW_URL,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.Initiate=mutation,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.Get=query,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetImages=infiniteQuery,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.Download=mutation,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetDownload=query,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetPricing=query,include.creativefabrica.backgroundremover.v2.BackgroundRemoverService.List=infiniteQuery,include.creativefabrica.vectorizer.v2.VectorizerService.Initiate=mutation,include.creativefabrica.vectorizer.v2.VectorizerService.List=infiniteQuery,include.creativefabrica.vectorizer.v2.VectorizerService.Get=query,include.creativefabrica.vectorizer.v2.VectorizerService.GetImages=infiniteQuery,include.creativefabrica.vectorizer.v2.VectorizerService.Download=mutation,include.creativefabrica.vectorizer.v2.VectorizerService.GetDownload=query,include.creativefabrica.social.v2.SocialService.GetUserFeaturedImages=query,include.creativefabrica.social.v2.SocialService.ListImageLibrary=query,include.creativefabrica.social.v2.SocialService.SelectFeaturedImages=mutation,include.creativefabrica.social.v2.SocialService.CreateSignedUrl=mutation,include.creativefabrica.social.v2.SocialService.PostProductProject=mutation,include.creativefabrica.social.v2.SocialService.ListAssets=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMachines=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMaterials=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListThemes=infiniteQuery,include.creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl=mutation,include.creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload=mutation,include.creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload=mutation,include.creativefabrica.studio.v2.StudioService.GetUserBanStatus=query,include.creativefabrica.content.v2.MarketplaceService.GetHomepageProductRecommendations=query,include.creativefabrica.studiofeed.v1.TemplateService.ListTemplates=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.InitiateSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.IterateSession=mutation,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListSessions=infiniteQuery,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.ListModels=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSession=query,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionImages=infiniteQuery,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionIterations=infiniteQuery,include.creativefabrica.studiomediamatrix.v1.StudioMediaMatrixService.GetSessionMedia=query,include.creativefabrica.preset.v1.AIProviderService.CalculateModelCost=query,include.creativefabrica.flow.v2.FlowService.CreateFlow=mutation,include.creativefabrica.flow.v2.FlowService.GetFlow=query,include.creativefabrica.flow.v2.FlowService.ListModels=query,include.creativefabrica.flow.v2.FlowService.ListPreviews=query,include.creativefabrica.flow.v2.FlowService.CreateDownloadUrl=mutation"
// @generated from file creativefabrica/backgroundremover/v2/service.proto (package creativefabrica.backgroundremover.v2, syntax proto3)
/* eslint-disable */

import type { InfiniteData, UseInfiniteQueryOptions, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { BackgroundRemoverService, GetPricingResponse, GetPricingRequestSchema } from "./service_pb";
import { InitiateResponse, InitiateRequestSchema, ListResponse, ListRequestSchema, GetResponse, GetRequestSchema, GetImagesResponse, GetImagesRequestSchema, DownloadResponse, DownloadRequestSchema, GetDownloadResponse, GetDownloadRequestSchema } from "@repo/rpc-types-creativefabrica-common-v1/imageprocessor/v1";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the BackgroundRemoverService service
 * Service: creativefabrica.backgroundremover.v2.BackgroundRemoverService
 */

let BackgroundRemoverServiceClient: ReturnType<typeof createClient<typeof BackgroundRemoverService>> | undefined

function getBackgroundRemoverServiceClient() {
  const baseUrl = process.env.NEXT_PUBLIC_RPC_BACKGROUNDREMOVER_URL
  invariant(baseUrl, 'NEXT_PUBLIC_RPC_BACKGROUNDREMOVER_URL env var is not set')
  BackgroundRemoverServiceClient ??= createClient(
    BackgroundRemoverService,
    createConnectTransport({
      baseUrl,
      useBinaryFormat: false,
      interceptors,
    }),
  )
  return BackgroundRemoverServiceClient
}

/**
 * Unique identifier for the GetPricing query
 */
export const GetPricingQueryRootKey = 'BackgroundRemoverService.GetPricing' as const;

/**
 * Return type for the GetPricing query
 */
type GetPricingQueryResult = GetPricingResponse;

/**
 * Generates a unique query key for the GetPricing query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetPricingQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getPricingQueryKey = /*@__PURE__*/ function getPricingQueryKey(variables?: MessageInitShape<typeof GetPricingRequestSchema>): QueryKey<MessageInitShape<typeof GetPricingRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetPricingRequestSchema>> = [GetPricingQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * GetPricing quotes what Initiate would charge for a given number of images.
 * Requires no signed-in user, so a price can be shown before sign-in.
 *
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetPricing
 */
/**
 * Function to execute the GetPricing RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getPricingFn(variables: MessageInitShape<typeof GetPricingRequestSchema>, meta?: Record<string, unknown>): Promise<GetPricingResponse> {
  return getBackgroundRemoverServiceClient().getPricing(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetPricing query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getPricingQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetPricingQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getPricingQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetPricingRequestSchema>): QueryOptions<GetPricingQueryResult, MessageInitShape<typeof GetPricingRequestSchema>> {
  return {
    queryKey: getPricingQueryKey(variables),
    queryFn: async (context) => getPricingFn(variables, context.meta)
  };
};


/**
 * GetPricing quotes what Initiate would charge for a given number of images.
 * Requires no signed-in user, so a price can be shown before sign-in.
 *
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetPricing
 */
export function useGetPricingQuery<D = GetPricingQueryResult, E = Error>(variables: MessageInitShape<typeof GetPricingRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetPricingQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetPricingRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetPricingQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetPricingRequestSchema>>
  >({
    ...options,
    ...getPricingQueryOptions(variables),
  });
}

/**
 * Unique identifier for the Initiate mutation
 */
export const InitiateMutationKey = 'BackgroundRemoverService.Initiate' as const;

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Initiate
 */
/**
 * Function to execute the Initiate RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function initiateFn(variables: MessageInitShape<typeof InitiateRequestSchema>, meta?: Record<string, unknown>): Promise<InitiateResponse> {
  return getBackgroundRemoverServiceClient().initiate(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Initiate
 */
export function useInitiateMutation(options?: Omit<
  UseMutationOptions<
    InitiateResponse,
    Error,
    MessageInitShape<typeof InitiateRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    InitiateResponse,
    Error,
    MessageInitShape<typeof InitiateRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => initiateFn(variables, options?.meta),
    mutationKey: [InitiateMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the List infinite query
 */
export const ListQueryRootKey = 'BackgroundRemoverService.List' as const;

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.List
 */
/**
 * Function to execute the List RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listFn(variables: MessageInitShape<typeof ListRequestSchema>, meta?: Record<string, unknown>) {
  return getBackgroundRemoverServiceClient().list(variables, createCallOptions(meta));
}

export function useListInfiniteQuery<D = ListResponse, TData = InfiniteData<D, string | undefined>>(
  variables: MessageInitShape<typeof ListRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListResponse,
      Error,
      TData,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.List
 */

/**
 * Unique identifier for the Get query
 */
export const GetQueryRootKey = 'BackgroundRemoverService.Get' as const;

/**
 * Return type for the Get query
 */
type GetQueryResult = GetResponse;

/**
 * Generates a unique query key for the Get query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getQueryKey = /*@__PURE__*/ function getQueryKey(variables?: MessageInitShape<typeof GetRequestSchema>): QueryKey<MessageInitShape<typeof GetRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetRequestSchema>> = [GetQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Get
 */
/**
 * Function to execute the Get RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getFn(variables: MessageInitShape<typeof GetRequestSchema>, meta?: Record<string, unknown>): Promise<GetResponse> {
  return getBackgroundRemoverServiceClient().get(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the Get query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetRequestSchema>): QueryOptions<GetQueryResult, MessageInitShape<typeof GetRequestSchema>> {
  return {
    queryKey: getQueryKey(variables),
    queryFn: async (context) => getFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Get
 */
export function useGetQuery<D = GetQueryResult, E = Error>(variables: MessageInitShape<typeof GetRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetRequestSchema>>
  >({
    ...options,
    ...getQueryOptions(variables),
  });
}

/**
 * Unique identifier for the GetImages infinite query
 */
export const GetImagesQueryRootKey = 'BackgroundRemoverService.GetImages' as const;

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetImages
 */
/**
 * Function to execute the GetImages RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getImagesFn(variables: MessageInitShape<typeof GetImagesRequestSchema>, meta?: Record<string, unknown>) {
  return getBackgroundRemoverServiceClient().getImages(variables, createCallOptions(meta));
}

export function useGetImagesInfiniteQuery<D = GetImagesResponse, TData = InfiniteData<D, string | undefined>>(
  variables: MessageInitShape<typeof GetImagesRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      GetImagesResponse,
      Error,
      TData,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [GetImagesQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof GetImagesRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return getImagesFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetImages
 */

/**
 * Unique identifier for the Download mutation
 */
export const DownloadMutationKey = 'BackgroundRemoverService.Download' as const;

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Download
 */
/**
 * Function to execute the Download RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function downloadFn(variables: MessageInitShape<typeof DownloadRequestSchema>, meta?: Record<string, unknown>): Promise<DownloadResponse> {
  return getBackgroundRemoverServiceClient().download(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.Download
 */
export function useDownloadMutation(options?: Omit<
  UseMutationOptions<
    DownloadResponse,
    Error,
    MessageInitShape<typeof DownloadRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    DownloadResponse,
    Error,
    MessageInitShape<typeof DownloadRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => downloadFn(variables, options?.meta),
    mutationKey: [DownloadMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the GetDownload query
 */
export const GetDownloadQueryRootKey = 'BackgroundRemoverService.GetDownload' as const;

/**
 * Return type for the GetDownload query
 */
type GetDownloadQueryResult = GetDownloadResponse;

/**
 * Generates a unique query key for the GetDownload query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetDownloadQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getDownloadQueryKey = /*@__PURE__*/ function getDownloadQueryKey(variables?: MessageInitShape<typeof GetDownloadRequestSchema>): QueryKey<MessageInitShape<typeof GetDownloadRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetDownloadRequestSchema>> = [GetDownloadQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetDownload
 */
/**
 * Function to execute the GetDownload RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getDownloadFn(variables: MessageInitShape<typeof GetDownloadRequestSchema>, meta?: Record<string, unknown>): Promise<GetDownloadResponse> {
  return getBackgroundRemoverServiceClient().getDownload(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetDownload query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getDownloadQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetDownloadQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getDownloadQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetDownloadRequestSchema>): QueryOptions<GetDownloadQueryResult, MessageInitShape<typeof GetDownloadRequestSchema>> {
  return {
    queryKey: getDownloadQueryKey(variables),
    queryFn: async (context) => getDownloadFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.backgroundremover.v2.BackgroundRemoverService.GetDownload
 */
export function useGetDownloadQuery<D = GetDownloadQueryResult, E = Error>(variables: MessageInitShape<typeof GetDownloadRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetDownloadQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetDownloadRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetDownloadQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetDownloadRequestSchema>>
  >({
    ...options,
    ...getDownloadQueryOptions(variables),
  });
}


